const { __ } = wp.i18n;
const { Fragment } = wp.element;
const { PanelBody, ToggleControl } = wp.components;

import renderHTML from "react-render-html";
const SidebarSettings = ( { handleShowComments, postStatus, commentBoardToggle } ) => {

	return (
		<div className="cf-settings-tab">
				<PanelBody>
					<ToggleControl
						label={__(
							"Hide Comments",
							"commenting-feature"
						)}
						className="comment-toggle"
						help={__(
							"When enabled, all the comment boxes will disappear to provide a non-distracted editing experience. You can still add a comment to your post. keyboard shortcuts to enable/disable — For Windows alt + Shift + J && For Mac ⌥ Option + Shift + J",
							"commenting-feature"
						)}
						checked={commentBoardToggle}
						onChange={
							handleShowComments.bind(this)
							
						}
					/>
				</PanelBody>
		</div>
	)

};

export default SidebarSettings;